<template>
  <div>
    <b-table
      :items="unResolvedList"
      :fields="columns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
    >
      <template #cell(created_at)="data">
        {{ data.item.created_at | formatDate }}
      </template>
      <template #cell(actions)="data">
        <b-button
          v-if="useResolveCondition(data.item)"
          class="text-success"
          variant="flat"
          :disabled="resolvingId === data.item.id"
          @click="resolveDriverInactivationReason(data.item.id)"
        >
          <b-spinner v-if="resolvingId === data.item.id" small />
          <span v-else>Resolve</span>
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BTable, BButton, BSpinner } from "bootstrap-vue";
import { computed, ref } from "@vue/composition-api";
import store from "@/store";
import useResolveCondition from "../useResolveCondition";

export default {
  components: {
    BTable,
    BButton,
    BSpinner,
  },
  props: {
    tableColumns: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const columns = computed(() => [...props.tableColumns, { key: "actions" }]);
    const unResolvedList = computed(
      () => store.getters["driverView/getUnResolvedInactivations"]
    );
    const resolvingId = ref(null);

    const resolveDriverInactivationReason = async (id) => {
      try {
        resolvingId.value = id;
        await ctx.root.$store.dispatch("driverView/resolveDriverInactivation", {
          inactivationId: id,
        });
        ctx.emit("refetch-inactivation-list");
        ctx.emit("refetch-driver-details");
      } catch (error) {
        console.log(error);
      } finally {
        resolvingId.value = null;
      }
    };
    return {
      columns,
      unResolvedList,
      resolveDriverInactivationReason,
      useResolveCondition,
      resolvingId,
    };
  },
};
</script>

<style></style>
